"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcExecutor = void 0;
const RpcInterceptor_1 = require("./RpcInterceptor");
/**
 * Executes RPC calls.
 *
 * Bridges application-provided RPC channel and interceptors with the generated
 * service code.
 */
class RpcExecutor {
    channel;
    interceptors;
    constructor(options) {
        this.channel = options.channel;
        this.interceptors = options.interceptors;
    }
    /**
     * Executes an RPC request.
     *
     * Builds the request, runs it through the interceptor stack, and then
     * delegates to the provided channel to execute the request.
     */
    async call(request, options) {
        const mergedRequest = this.buildRequest(request, options);
        const next = this.mergeInterceptorStack(options);
        const call = await next(mergedRequest);
        const res = await call.execute();
        return res.data;
    }
    buildRequest(request, options) {
        return {
            path: request.path,
            service: request.service,
            method: options.overrideMethod ? { ...request.method, ...options.overrideMethod } : request.method,
            data: request.data,
            headers: { ...request.headers, ...options.headers },
            context: { ...request.context, ...options.context },
        };
    }
    mergeInterceptorStack(options) {
        const interceptors = [
            ...(this.interceptors.interceptors ?? []),
            ...(options.interceptors ?? []),
            ...(this.interceptors.lastInterceptors ?? [])
        ];
        let next = (req) => Promise.resolve(new RpcCallImpl(req, this.channel));
        for (const interceptor of interceptors.reverse()) {
            const localNext = next;
            next = (req) => interceptor.intercept(localNext, req);
        }
        return next;
    }
}
exports.RpcExecutor = RpcExecutor;
/**
 * Implementation of an RPC call which makes the actual call using the provided
 * `channel`.
 */
class RpcCallImpl extends RpcInterceptor_1.RpcCall {
    channel;
    constructor(request, channel) {
        super(request);
        this.channel = channel;
    }
    async execute() {
        const { channel, request } = this;
        const basePath = request.path.endsWith('/') ? request.path : `${request.path}/`;
        const response = await channel.execute({
            path: `${basePath}${request.service.name}/${request.method.name}`,
            dataJson: request.method.requestType.toJSON(request.data),
            headers: request.headers,
        });
        return {
            data: request.method.responseType.fromJSON(response.dataJson),
            statusCode: response.statusCode,
            headers: response.headers,
        };
    }
}
//# sourceMappingURL=RpcExecutor.js.map